import { useState } from 'react';
import { useAngularService } from './get_angular_service';
import { useResponsive } from './use_responsive';

export function useFiltersOpen(key: string, defaultOpen = false, shouldSkip?: boolean) {
  const storageKey = `${key}FiltersOpen`;
  const CwStorage = useAngularService('CwStorage');
  const { isMobile } = useResponsive();

  const [open, _toggle] = useState(() => {
    const val = JSON.parse(CwStorage.getItem(storageKey));
    return val !== null ? val : defaultOpen;
  });

  const toggle = (val) => {
    _toggle(val);
    if (val || defaultOpen) {
      if (shouldSkip) return;
      CwStorage.setItem(storageKey, val);
    } else {
      CwStorage.removeItem(storageKey);
    }
  };

  return [isMobile ? false : open, toggle];
}
